import {createEffect} from "effector";
import { getHighRollers } from "../api/high-roller.api";


export const highRollerFX = createEffect(async () => {
    const response = await getHighRollers();
    return response.data
})
